import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import style from './OpenPriceField.module.scss';

export const OpenPriceField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<FullInfoField
			containerClassName={style.flex1}
			label="supplierNameLabel"
			value={restaurantForFullInfo?.openPricePercent}
		/>
	);
};
